import Header from '@/components/layout/Header';
import CheckoutFab from '@/components/layout/CheckoutFab';
import ProductListing from '@/components/products/ProductListing';
import { useCode } from '@/hooks/use-code';
import { useShop } from '@/hooks/queries/use-shop';

// HACK: a quick way to hide products in shop
const hidden: string[] = ["dbcaff53-0f73-b986-ebca-55c48df544cf"];

export default function Products() {
  const code = useCode();
  const { data: shop } = useShop(code);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header variant="default" />

        <main className="grow">
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto mb-12">
            {/* Page header */}
            <div className="mb-8">
              {/* Title */}
              <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold text-center">
                Köp och stötta vår insamling!
              </h1>
              <div className="text-gray-500 dark:text-gray-400 mt-1 text-center">
                Stöd mig och {shop.group.name} genom att beställa produkter nedan. Vi tjänar mella 40% och 50% på allt du köper.
              </div>
            </div>

            <div>
              <div className="grid grid-cols-12 gap-6">
                {/* // HACK: a quick way to hide certain products in shop */ }
                {shop.products.filter(p => !hidden.includes(p.id)).map((product) => (
                  <ProductListing product={product} key={product.id} />
                ))}
              </div>
            </div>
          </div>
          <CheckoutFab />
        </main>
      </div>
    </div>
  );
}
